// Player color palette used for unit/city tinting across the renderer.
// Hex strings are picked to be distinguishable both at a glance and
// across common colorblind variants (the colorblind palette swaps are
// applied as a settings-layer transform, not here).

export const PLAYER_COLORS: readonly string[] = [
  '#3b82f6', // P0 blue
  '#f97316', // P1 orange
  '#dc2626', // P2 red
  '#16a34a', // P3 green
  '#a855f7', // P4 purple
  '#eab308', // P5 yellow
  '#06b6d4', // P6 cyan
  '#ec4899', // P7 pink
];

const NEUTRAL_COLOR = '#888888';

/**
 * Resolve a stable hex color for a given player id. Cycles through the
 * palette for ids beyond the array length (so id 8 lands on blue again,
 * id 9 on orange, etc.). Returns the neutral gray for undefined owners
 * (wild units, neutral cities, decorative spawns).
 */
export function playerColor(playerId: number | undefined | null): string {
  if (playerId === undefined || playerId === null) return NEUTRAL_COLOR;
  if (playerId < 0) return NEUTRAL_COLOR;
  return PLAYER_COLORS[playerId % PLAYER_COLORS.length] ?? NEUTRAL_COLOR;
}
